import type { Page } from '../../types';

export const CORE_DEPARTMENTS = [
  'Cabinet Office',
  'Department for Business and Trade',
  'Department for Culture, Media and Sport',
  'Department for Environment, Food and Rural Affairs',
  'Department for Education',
  'Department for Energy Security and Net Zero',
  'Department for Transport',
  'Department of Health and Social Care',
  'Department for Science, Innovation and Technology',
  'Department for Work and Pensions',
  'Foreign, Commonwealth and Development Office',
  'HM Revenue and Customs',
  'HM Treasury',
  'Home Office',
  'Ministry of Housing, Communities and Local Government',
  'Ministry of Defence',
  'Ministry of Justice',
];

const coverSheet: Page[] = [
  {
    pageType: 'question',
    title: 'Cover Sheet',
    name: 'cover-sheet',
    questions: [
      {
        questionType: 'select',
        title: 'Please select your Department',
        name: 'department',
        options: CORE_DEPARTMENTS,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'reportPeriod',
        title: 'Period of Report',
        name: 'report-period',
        defaultValue: 'auto',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'dataLoad',
        title: 'Pre-populate data',
        hint: 'If you have been given a PIN number, enter it here to auto-populate your CS jobs and/or Qualtrix data',
        name: 'contact-pin',
        lookupQuestion: 'report-period',
        successMessage: 'CS Jobs/Qualtrix data has been prepopulated into your form',
        rules: {
          required: false,
        },
      },
      {
        questionType: 'textInput',
        title: 'Point of Contact',
        name: 'contact-email',
        hint: "Please enter your point of contact's email address",
        rules: {
          required: true,
          email: true,
        },
      },
      {
        questionType: 'textInputSmall',
        title: 'Headcount',
        name: 'contact-headcount',
        hint: 'Please clarify the headcount of department & agencies covered by your reporting.',
        rules: {
          required: true,
          number: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Recruitment Operating Model',
        name: 'contact-operating-model',
        hint: 'Please indicate whether recruitment at a practical level is conducted by a central team, line managers, or a mixture.',
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default coverSheet;
